"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const material_1 = require("@mui/material");
const x_date_pickers_1 = require("@mui/x-date-pickers");
const moment_1 = __importDefault(require("moment"));
const react_2 = require("react");
const App_1 = require("../../App");
const api_1 = __importDefault(require("../../services/api"));
const react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
const utils_1 = require("../../functions/utils");
const x_data_grid_1 = require("@mui/x-data-grid");
const Footer_1 = __importDefault(require("../../components/Footer"));
const Publicar = () => {
    const [nomeFile, setNomeFile] = (0, react_2.useState)("");
    const [tipoArquivo, settipoArquivo] = (0, react_2.useState)("ppa");
    const [dataInicial, setDataInicial] = (0, react_2.useState)(new Date().toDateString());
    const [selectedFile, setSelectedFile] = (0, react_2.useState)();
    const [loading, setLoading] = (0, react_2.useState)(false);
    const [data, setData] = (0, react_2.useState)();
    const [getFiles, setGetFiles] = (0, react_2.useState)(true);
    const [inPageFilter, setInPageFilter] = (0, react_2.useState)("");
    const [filterData, setFilterData] = (0, react_2.useState)([{}]);
    const [pageSize, setPageSize] = (0, react_2.useState)(10);
    const [disableButtons, setDisableButtons] = (0, react_2.useState)(false);
    const [warningMessage, setWarningMessage] = (0, react_2.useState)("");
    const { user, windowDimensions, backGroundColor, orgaoAUsar } = (0, react_2.useContext)(App_1.UserContext);
    (0, react_2.useEffect)(() => {
        if (getFiles && user.orderNo) {
            api_1.default
                .get("/file", {
                params: {
                    user: user.orderNo,
                },
            })
                .then((response) => {
                const formatData = [];
                response.data.map((file) => {
                    const formatreg = {
                        id: file.ID,
                        fileURL: utils_1.baseAnexosURL + file.FILE,
                        fileName: file.NOME_EXIBE ? (0, utils_1.decodeUtf8)(file.NOME_EXIBE) : (0, utils_1.decodeUtf8)((0, utils_1.getFileName)(file.FILE)),
                        municipioId: file.MUNICIPIO_ID,
                        extensao: (0, utils_1.getFileExtension)(file.FILE),
                        ano: file.YEAR,
                        tipo: file.DESCRICAO,
                    };
                    formatData.push(formatreg);
                });
                setData(formatData);
                setFilterData(formatData);
                setLoading(false);
                setGetFiles(false);
            });
        }
    }, [getFiles, user.orderNo]);
    (0, react_2.useEffect)(() => {
        setDisableButtons(true);
        setNomeFile("");
        setSelectedFile(undefined);
        switch (tipoArquivo) {
            case "patrimonio":
                setWarningMessage(`A publicação de patrimônio é feita pelo aplicativo PATRIMONIO X5, para maiores informações <a href="https://www.fenix.com.br/ftp/patrimoniox5/HTML/publicacao-do-anexo-pdf-no-por.htm" target="_blank">Clique Aqui</a>`);
                setDisableButtons(true);
                break;
            case "patrimonioImovel":
                setWarningMessage(`A publicação de patrimônio Imóvel é feita pelo aplicativo PATRIMONIO X5, para maiores informações <a href="https://www.fenix.com.br/ftp/patrimoniox5/HTML/sinc_obras_portal_transparencia.htm" target="_blank">Clique Aqui</a>`);
                setDisableButtons(true);
                break;
            case "balancete":
                setWarningMessage(`A publicação do balancete financeiro é feita pelo aplicativo GERENCIAL, para maiores informações <a href="https://www.fenix.com.br/ftp/gerencial/HTML/publicacao_anexos_dcasp_portal.htm" target="_blank">Clique Aqui</a>`);
                setDisableButtons(true);
                break;
            case "programa":
                setWarningMessage(`A publicação de programas e ações é feita pelo aplicativo CONTAB, para maiores informações <a href="https://www.fenix.com.br/ftp/contab2010/HTML/publicacao_pdfs_portal.htm" target="_blank">Clique Aqui</a>`);
                setDisableButtons(true);
                break;
            default:
                setDisableButtons(false);
                setWarningMessage("");
                break;
        }
    }, [tipoArquivo]);
    const handleUpload = () => {
        // Create an object of formData
        const formData = new FormData();
        // Update the formData object
        if (selectedFile !== undefined) {
            formData.append("file", selectedFile);
        }
        setLoading(true);
        // Request made to the backend api
        // Send formData object
        api_1.default
            .post("/file", formData, {
            params: {
                orderNo: user.orderNo,
                ano: (0, moment_1.default)(dataInicial).format("YYYY"),
                tipo: tipoArquivo,
                nomeExibe: nomeFile,
            },
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then(() => {
            react_toastify_1.toast.success("Publicação de Arquivo feita com sucesso", { draggablePercent: 60 });
            setNomeFile("");
            setSelectedFile(undefined);
            setLoading(false);
            setGetFiles(true);
        })
            .catch((error) => {
            react_toastify_1.toast.error(error, { draggablePercent: 60 });
        });
    };
    const handleDownload = (params) => {
        (0, utils_1.downloadURI)(params.fileURL);
    };
    const handleDelete = (params) => {
        api_1.default
            .delete("/file", {
            params: {
                id: params.id,
            },
        })
            .then(() => {
            react_toastify_1.toast.success("Arquivo Deletado com sucesso", { draggablePercent: 60 });
            setGetFiles(true);
        })
            .catch((error) => {
            react_toastify_1.toast.error(error, { draggablePercent: 60 });
        });
    };
    const columns = [
        {
            field: "id",
            headerName: "id",
            width: 70,
            headerClassName: "table__header",
            hide: true,
        },
        {
            field: "tipo",
            headerName: "Tipo do Arquivo",
            width: 250,
            hide: windowDimensions.width < 800 ? true : false,
            cellClassName: "wrap",
        },
        {
            field: "fileName",
            headerName: "Descrição do Arquivo",
            flex: 1,
            minWidth: 140,
            cellClassName: "wrap",
        },
        {
            field: "ano",
            headerName: "Ano",
            hide: windowDimensions.width < 600 ? true : false,
            width: 60,
            cellClassName: "wrap",
        },
        {
            field: "extensao",
            headerName: "Tipo",
            hide: windowDimensions.width < 1368 ? true : false,
            width: 120,
            cellClassName: "wrap",
        },
        {
            field: "click",
            headerName: "Ações",
            flex: 1,
            maxWidth: 180,
            cellClassName: "wrap",
            hide: windowDimensions.width < 300 ? true : false,
            renderCell: (params) => {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(material_1.Button, { style: { marginLeft: 5, padding: 5 }, className: `button__text ${backGroundColor ? 'highContrast borderContrast' : ''}`, onClick: () => handleDownload(params.row), variant: "contained", color: "warning" }, "Visualizar"),
                    react_1.default.createElement(material_1.Button, { style: { marginLeft: 5, padding: 5 }, className: `button__text ${backGroundColor ? 'highContrast borderContrast' : ''}`, onClick: () => handleDelete(params.row), variant: "contained", color: "error" }, "Excluir")));
            },
        },
    ];
    const handleSearchChange = (e) => {
        setInPageFilter(e.target.value);
        const value = e.target.value.toLowerCase();
        if (data) {
            const filterLines = data.filter((line) => {
                return (line.extensao.toLowerCase().includes(value) ||
                    line.fileName.toLowerCase().includes(value) ||
                    line.ano.toString().toLowerCase().includes(value));
            });
            setFilterData(filterLines);
        }
    };
    const VisuallyHiddenInput = (0, material_1.styled)("input") `
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
  `;
    return (react_1.default.createElement("div", { className: `page ${backGroundColor ? 'highContrast' : ''}` },
        react_1.default.createElement(react_toastify_1.ToastContainer, { draggable: true }),
        react_1.default.createElement("div", { className: "card__parent" },
            react_1.default.createElement("div", { className: "title" },
                react_1.default.createElement("p", null, `Publicação de Arquivos ${user.name}`)),
            !warningMessage && (react_1.default.createElement("div", { className: "", style: {
                    margin: "auto",
                    textAlign: "center",
                    paddingTop: "10px",
                    height: "50px",
                    color: "#31708f",
                    backgroundColor: "#d9edf7",
                    borderColor: "#bce8f1",
                    width: "50%",
                    display: `${selectedFile ? "none" : ""}`,
                    marginBottom: "10px",
                } },
                react_1.default.createElement("strong", null, "Informa\u00E7\u00E3o"),
                " ",
                react_1.default.createElement("br", null),
                "Selecione um arquivo para realizar o upload!")),
            warningMessage && (react_1.default.createElement("div", { className: "", style: {
                    margin: "auto",
                    textAlign: "center",
                    paddingTop: "10px",
                    height: "50px",
                    color: "#31708f",
                    backgroundColor: "#ffe7e7",
                    borderColor: "#bce8f1",
                    width: "50%",
                    display: `${selectedFile ? "none" : ""}`,
                    marginBottom: "10px",
                } },
                react_1.default.createElement("strong", null, "Aviso"),
                " ",
                react_1.default.createElement("br", null),
                react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: warningMessage } }))),
            react_1.default.createElement("div", { className: "flex__firstRow", style: { display: "flex", flexDirection: "row", marginBottom: "20px" } },
                react_1.default.createElement("div", { className: "firstRow__field ", style: { flex: 2 } },
                    react_1.default.createElement(material_1.InputLabel, { id: "tipoArquivo", className: "search__label search__label__tipoArquivo", style: { maxWidth: 80 } }, "Tipo do arquivo"),
                    react_1.default.createElement(material_1.Select, { labelId: "tipoArquivo", id: "demo-simple-select", value: tipoArquivo, label: "\u00D3rg\u00E3o", onChange: (e) => {
                            settipoArquivo(e.target.value);
                        }, className: "firstRow__field__select", size: "small" },
                        react_1.default.createElement(material_1.MenuItem, { value: "ppa" }, "Plano Plurianual e Acompanhamento de Programas e A\u00E7\u00F5es"),
                        react_1.default.createElement(material_1.MenuItem, { value: "ldo" }, "Lei de Diretrizes Or\u00E7ament\u00E1rias"),
                        react_1.default.createElement(material_1.MenuItem, { value: "loa" }, "Lei Or\u00E7ament\u00E1ria Anual"),
                        react_1.default.createElement(material_1.MenuItem, { value: "metas" }, "Anexos, metas riscos"),
                        react_1.default.createElement(material_1.MenuItem, { value: "balanco" }, "Balan\u00E7o Geral"),
                        react_1.default.createElement(material_1.MenuItem, { value: "balancete" }, "Balancete Financeiro"),
                        react_1.default.createElement(material_1.MenuItem, { value: "patrimonio" }, "Patrim\u00F4nio Bens M\u00F3veis"),
                        react_1.default.createElement(material_1.MenuItem, { value: "patrimonioImovel" }, "Patrim\u00F4nio Bens Im\u00F3veis"),
                        react_1.default.createElement(material_1.MenuItem, { value: "programa" }, "Programas e A\u00E7\u00F5es - Conforme Art 3\u00BA,\u00A7 5\u00BA TAG 2018."),
                        react_1.default.createElement(material_1.MenuItem, { value: "covid" }, "Combate ao CORONAV\u00CDRUS"))),
                react_1.default.createElement("div", { className: "firstRow__field ", style: { flex: 1 } },
                    react_1.default.createElement(material_1.InputLabel, { id: "dtInicial", className: `search__label search__label__mes` }, "Ano"),
                    react_1.default.createElement(x_date_pickers_1.DatePicker, { inputFormat: "YYYY", value: dataInicial, onChange: (newvalue) => (newvalue ? setDataInicial(newvalue.toString()) : ""), views: ["year"], renderInput: (params) => react_1.default.createElement(material_1.TextField, Object.assign({ size: "small" }, params)), className: `firstRow__field__dates`, minDate: new Date("2010-01-01"), maxDate: new Date("2025-12-31") })),
                react_1.default.createElement("div", { className: "firstRow__field ", style: { marginTop: 20, marginLeft: 20 } },
                    react_1.default.createElement(material_1.Button, { component: "label", variant: "contained", href: "#file-upload", disabled: disableButtons },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFile, style: { marginRight: 7 } }),
                        "Selecione o arquivo",
                        react_1.default.createElement(VisuallyHiddenInput, { type: "file", onChange: (e) => {
                                if (e.target && e.target instanceof HTMLInputElement && e.target.files) {
                                    const file = e.target.files[0];
                                    setSelectedFile(file);
                                    setNomeFile(file.name);
                                    // You can now use 'selectedFile' as the selected file.
                                    // setSelectedFile(selectedFile);
                                }
                            } })),
                    react_1.default.createElement("p", { style: { marginTop: 2 } }, nomeFile))),
            react_1.default.createElement("div", { className: "flexRow", style: { display: "flex", flexDirection: "row" } },
                react_1.default.createElement("div", { className: "flex__firstRow", style: { display: "flex", flexDirection: "column", margin: "0 10px" } },
                    react_1.default.createElement(material_1.InputLabel, { id: "pesquisaAvancada", className: "search__label", style: { maxWidth: 180 } }, "Nome do Arquivo a Ser Exibido"),
                    react_1.default.createElement(material_1.TextField, { label: "", value: nomeFile, size: "small", type: "text", disabled: !selectedFile, className: "form__input", inputProps: {
                            autoCapitalize: 'none',
                            className: 'form__input'
                        }, onChange: (e) => {
                            setNomeFile(e.target.value);
                        }, style: { width: 500, marginBottom: 20 } })),
                react_1.default.createElement("div", { className: "button", style: { marginTop: 20, marginLeft: 20 } },
                    react_1.default.createElement(material_1.Button, { variant: "contained", disabled: nomeFile === "" || selectedFile === undefined, onClick: handleUpload },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faUpload }),
                        react_1.default.createElement("span", { className: "p10_left" }, "Enviar"))),
                loading && react_1.default.createElement(material_1.CircularProgress, null))),
        react_1.default.createElement("div", { className: "title" },
            react_1.default.createElement("p", null, `Arquivos Publicados`)),
        data && !loading && (react_1.default.createElement("div", { className: "table__container sm-center " },
            react_1.default.createElement("div", { className: "table__export__container flex m1" },
                react_1.default.createElement("div", { className: "search__avancada flex--1" },
                    react_1.default.createElement("span", { id: "pesquisaAvancada", className: `search__text ${backGroundColor ? 'colorContrast' : ''}` }, "Pesquisa Por:"),
                    react_1.default.createElement("input", { value: inPageFilter, className: "search__input", onChange: (e) => handleSearchChange(e) }))),
            react_1.default.createElement("div", { className: `table ${backGroundColor ? 'colorContrast' : ''} `, id: "table" },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(x_data_grid_1.DataGrid, { rows: filterData, initialState: {
                            sorting: {
                                sortModel: [{ field: "ano", sort: "desc" }],
                            },
                        }, columns: columns, pageSize: pageSize, onPageSizeChange: (newPageSize) => setPageSize(newPageSize), rowsPerPageOptions: [10, 30, 50, 100], autoHeight: true, className: `table ${backGroundColor ? 'colorContrast' : ''} `, headerHeight: 45, pagination: true, localeText: (0, utils_1.customPtBRText)(), onStateChange: (state) => {
                            const visibleRows = state.filter.visibleRowsLookup;
                            const visibleItems = [];
                            for (const [id, value] of Object.entries(visibleRows)) {
                                if (value === true) {
                                    visibleItems.push(id);
                                }
                            }
                            const res = data.filter((item) => visibleItems.includes(item.id.toString()));
                        } }))))),
        react_1.default.createElement(Footer_1.default, null)));
};
exports.default = Publicar;
